<template>
  <section class="terms-section header-space-custom">
    <!-- <BannerSlider
      v-if="bannersBrij && bannersBrij.length > 0"
      :BannerData="bannersBrij"
      :key="componentKeyBanner"
    /> -->

    <!--Start Static Banners Sliders--->
    <section class="section-banner header-space">
      <slick ref="bannerslider" :options="bannerSlider">
        <!-- <div
        v-for="(data, index) in bannersBrij"
        :key="index"
        class="w-100 banner-slider"
      > -->
        <div class="banner-img">
          <div>
            <!-- <img :src="data.web_banner_img" class="banner-movie-img" /> -->
            <!-- APP BANNER -->
            <img
              src="@/assets/img/400x500.jpg"
              class="banner-movie-img d-block d-md-none"
              onerror="javascript:this.src='/static/img/default-banner.jpg'"
            />
            <!-- WEB BANNER -->
            <img
              src="@/assets/img/1520x500.jpg"
              class="banner-movie-img d-none d-md-block"
              onerror="javascript:this.src='/static/img/1520x500.jpg'"
            />
            <!-- <div v-if="data.movie == true" class="banner-overlay">
              <img
                src="@/assets/img/new-img/jpg-img/banner-overlay.png"
                class="banner-overlay-img"
              />
            </div> -->
          </div>
        </div>
        <!-- </div> -->
      </slick>
    </section>
    <!--End Static Banners Sliders--->

    <div class="container">
      <form @submit.prevent="formSubmit">
        <div class="d-block">
          <h3>{{ allLanguageData.Join_our_young }}</h3>
          <p>{{ allLanguageData.Are_u_sociable }}</p>
          <p>{{ allLanguageData.Do_you_have }}</p>
          <p>{{ allLanguageData.Then_join_us }}</p>
          <!--Operational jobs--->
          <div class="d-flex mb-3">
            <div class="col-6 font-bold">
              {{ allLanguageData.Carrer[0].title }}
            </div>

            <div
              class="d-flex col-6"
              :class="langName == 'ar' ? 'pr-0' : 'pl-0'"
            >
              <!-- <b-form-checkbox
                id="checkbox-1"
                v-model="carrerDeatils.status1"
                name="checkbox-1"
                value="Y"
                unchecked-value="N"
              >
                {{ allLanguageData.Carrer[1].title }}
              </b-form-checkbox> -->
              <!-- <div>{{ carrerDeatils.status1 }}</div> -->
              <!-- <b-form-checkbox
                id="checkbox-2"
                v-model="carrerDeatils.status2"
                name="checkbox-2"
                value="Y"
                unchecked-value="N"
              >
                {{ allLanguageData.Carrer[2].title }}
              </b-form-checkbox> -->

              <b-form-radio
                v-model="carrerDeatils.status"
                value="Operational"
                name="some-radios"
                v-on:change="onFeildChange('Operational')"
              >
                {{ allLanguageData.Carrer[1].title }}
              </b-form-radio>

              <b-form-radio
                v-model="carrerDeatils.status"
                value="Corporate"
                name="some-radios"
                v-on:change="onFeildChange('Corporate')"
                >{{ allLanguageData.Carrer[2].title }}</b-form-radio
              >
            </div>
          </div>

          <!---Full Name-->
          <div class="d-flex mb-3">
            <div class="col-6 d-flex align-items-center font-bold">
              {{ allLanguageData.Carrer[3].title }}
            </div>

            <b-form-input
              v-model="carrerDeatils.fullName"
              type="text"
              class="carrer_input"
            />
          </div>

          <!---Email-->
          <div class="d-flex mb-3">
            <div class="col-6 d-flex align-items-center font-bold">
              {{ allLanguageData.Carrer[4].title }}
            </div>

            <b-form-input
              v-model="carrerDeatils.Email"
              type="email"
              class="carrer_input"
            />
          </div>

          <!--Mobile Number-->
          <div
            class="d-flex mb-3"
            :class="langName == 'ar' ? 'carrer_mobile_ar' : 'carrer_mobile'"
          >
            <div class="col-6 d-flex align-items-center font-bold">
              {{ allLanguageData.Carrer[5].title }}
            </div>

            <vue-phone-number-input
              color="#cf1f2e"
              default-country-code="SA"
              v-model="carrerDeatils.Mobile"
              @update="onUpdate"
              :dir="langName === 'ar' ? 'rtl' : 'ltr'"
              :translations="computedTranslations"
            />
            <!-- @update="resultsExample = $event" -->
            <!-- <span
              >{{ carrerDeatils.fullmobnumber }}
              {{ carrerDeatils.Mobile }}</span
            > -->
          </div>
          <!-- <table class="mr-2">
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
            <tr v-for="item in resultsTable" :key="item" class="w-100">
              <td>
                {{ item }}
              </td>
              <td>{{ results[item] }}</td>
            </tr>
          </table> -->

          <!-- <div class="flex flex-direction-column flex-1">
            <b>Payload:</b>
            {{ results.formatInternational }}
          </div> -->

          <!---City u live -->
          <div class="d-flex mb-3">
            <div class="col-6 d-flex align-items-center font-bold">
              {{ allLanguageData.Carrer[6].title }}
            </div>

            <!-- <multiselect
              v-model="carrerDeatils.CityName"
              :options="cityOptions"
              label="text"
              track-by="value"
              class="carrer_input"
              :select-label="''"
              :deselect-label="''"
              :placeholder="langName === 'ar' ? 'اختر مدينة' : 'Select City'"
              :selectedLabel="''"
            >
            </multiselect> -->
            <multiselect
              v-model="carrerDeatils.CityName"
              :options="translatedStates"
              label="state_name_ar"
              track-by="state_id"
              class="carrer_input"
              :select-label="''"
              :deselect-label="''"
              :placeholder="langName === 'ar' ? 'اختر مدينة' : 'Select City'"
              :selectedLabel="''"
              :class="{ 'multiselect-arabic': langName === 'ar' }"
              :style="{
                textAlign: langName === 'ar' ? 'right' : 'left',
              }"
            >
            </multiselect>
            <!-- <div>{{ carrerDeatils.CityName.text }}</div> -->
          </div>

          <!---Upload cv-->
          <div class="d-flex mb-3">
            <div class="col-6 align-items-center font-bold">
              {{ allLanguageData.Carrer[7].title }}
              <p
                class="mb-0 errorMessage"
                :class="langName == 'ar' ? 'text-right' : 'text-left'"
                style="color: red"
              >
                ({{ allLanguageData.OnlyPdf }})
              </p>
            </div>

            <!-- <b-input-group>
            <b-form-file
              id="form-image"
              :disabled="busy"
              accept="image/pdf"
            ></b-form-file>
          </b-input-group> -->
            <div
              class="col-md-4 col-6 d-flex flex-column px-0"
              :class="langName == 'ar' ? 'pl-md-2' : 'pr-md-2'"
            >
              <div class="text-center mb-2">
                <input
                  :id="
                    langName == 'ar'
                      ? 'uploadFilecarrer_ar'
                      : 'uploadFilecarrer'
                  "
                  :placeholder="langName === 'ar' ? 'لا ملف' : FileName"
                  disabled="disabled"
                />
              </div>

              <label class="custom-file-upload-carrer btn">
                <input
                  type="file"
                  id="resume"
                  v-on:change="uploadImage($event)"
                  accept="application/pdf,.doc,.docx,application/msword"
                  class="d-none"
                  name="resume"
                />
                {{ allLanguageData.Carrer[8].title }}
              </label>
            </div>
          </div>

          <!-- <div>
            {{ FileName }}
          </div> -->
          <!--Tell us -->
          <div class="d-flex mb-3">
            <div class="col-6 d-flex align-items-center font-bold">
              {{ allLanguageData.Carrer[9].title }}
            </div>

            <textarea
              v-model="carrerDeatils.Message"
              type="text"
              cols="20"
              rows="4"
              v-on:input="check"
              class="carrer_input"
            >
            </textarea>
            <!-- <p>
            {{ instruction }}
          </p> -->
          </div>

          <div class="my-2 errorMessage text-center" style="color: red">
            {{
              carrerDeatils.errorMessage && langName === "ar"
                ? "الرجاء اختيار أي حقل"
                : carrerDeatils.errorMessage
            }}
            <!-- {{
              langName === "ar"
                ? "الرجاء اختيار أي حقل"
                : carrerDeatils.errorMessage
            }} -->
          </div>
          <div class="text-center d-flex">
            <div class="col-6">
              <b-button class="btn popup-btn mt-md-3 my-3 invisible">
                {{ allLanguageData.ContactUsModal.Btn }}
              </b-button>
            </div>
            <div class="col-6 d-flex justify-start">
              <b-button
                v-on:click="onFinalSubmit()"
                class="btn popup-btn mt-md-3 my-3"
              >
                {{ allLanguageData.ContactUsModal.Btn }}
              </b-button>
            </div>
          </div>

          <!--For More Information-->
          <div class="col-12 d-block">
            <h5 class="font-bold">
              {{ allLanguageData.for_moreinfo }}
            </h5>
            <p>
              jobs@empirecinemas.com.sa /
              <a href="tel:+966 114646111">+966 114646111</a>
            </p>
          </div>

          <!--Succesful Message Modal-->
          <b-modal
            id="modal_1"
            ref="modal_1"
            title="BootstrapVue"
            hide-header
            hide-footer
          >
            <div
              class="d-flex justify-content-center flex-column align-items-center"
            >
              <p class="my-4 text-center font-bold">
                {{ allLanguageData.Thanks_for_sub }}
              </p>
              <img
                src="@/assets/img/svg/done_career.svg"
                class="custom-width-svg"
              />
            </div>
          </b-modal>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import BannerSlider from "@/components/partials/bannerSlider.vue";
import axios from "axios";
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import $ from "jquery";
import { BASEURL_BRIJ } from "../../config";
import { URL_BASE } from "@/helper/constant";
import {
  LanguageService,
  CountryService,
  TokenService,
} from "@/services/storage.service";
import { EventBus } from "@/main";

export default {
  components: {
    BannerSlider,
  },

  data() {
    return {
      bannerSlider: {
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
      results: {
        // formatInternational: "",
      },
      FileName: "No File",
      ImageURL: "",

      resultsExample: null,
      cityOptions: [
        // { value: null, text: "Please select City", disabled: true },
      ],
      error: [],
      limit: 500,
      chekboxes: {
        errorMessage: "",
      },
      carrerDeatils: {
        fullName: "",
        Email: "",
        fullmobnumber: "",
        Mobile: "",
        Message: "",
        CountryID: null,
        CityID: null,
        CityName: "",
        errorMessage: "",
        status: "",
        status1: "",
        status2: "",
      },
      translatedStates: [],
      translations: {
        countrySelectorLabel: "رمز البلد",
        countrySelectorError: "اختر بلداً",
        phoneNumberLabel: "رقم الهاتف",
        example: "مثال:",
      },
    };
  },

  computed: {
    bannersBrij() {
      return this.$store.getters.getBanners;
    },
    // instruction: function() {
    //   if (this.carrerDeatils.Message == "") {
    //     "Max Limit" + this.limit + " characters";
    //     return true;
    //   }
    // },
    resultsTable() {
      Object.keys(this.results);
    },
    computedTranslations() {
      return this.langName === "ar" ? this.translations : {};
    },
  },
  beforeMount() {
    this.fetchCities();
  },
  methods: {
    onFeildChange: function(value) {
      this.carrerDeatils.status = value;
    },
    onUpdate(payload) {
      this.results = payload;
    },
    check: function() {
      this.carrerDeatils.Message = this.carrerDeatils.Message.substr(
        0,
        this.limit
      );
    },

    getBannerList() {
      this.homeBanners = [];
      let payload = {
        CinemaID: this.headerCinemaId,
      };
      // makeRequest('/GetBanners/', 'POST', null, payload)
      //   .then(response => {
      //     const { error, res } = response
      //     if (
      //       res.data.Status &&
      //       res.data.Banners &&
      //       res.data.Banners.length > 0
      //     ) {
      //       this.homeBanners = res.data.Banners
      //     }
      //   })
      //   .catch(error => {
      //     console.log('Error', error)
      //   })
    },
    translateToArabic(stateName) {
      const translations = {
        Arar: "عرعر",
        YANBU: "ينبع",
        TAIF: "الطائف",
        QATIF: "القطيف",
        JUBAIL: "الجبيل",
        JOUF: "الجوف",
        JEDDAH: "جدة",
        DHAHRAN: "الظهران",
        DAMMAM: "الدمام",
        "AL AHSA": "الأحساء",
        ABHA: "أبها",
        RIYADH: "الرياض",
        MADINAH: "المدينة المنورة",
        TABOUK: "تبوك",
        QASSEM: "القصيم",
        NAJRAN: "نجران",
        MAKKAH: "مكة",
        JAZAN: "جازان",
        Hail: "حائل",
        "AL KHOBAR": "الخبر",
      };
      return translations[stateName] || stateName;
    },
    fetchCities() {
      var config = {
        method: "get",
        url: `${
          this.BrijBaseUrl
        }/api/get_ms_states_list?state_is_active=Y&country_id=191`,
      };

      // axios(config)
      //   .then((result) => {
      //     const { error, data } = result;
      //     if (data.Records && data.Records.length) {
      //       this.cityOptions = data.Records.map((val) => {
      //         return {
      //           value: val.state_id || "",
      //           text: val.state_name || "",
      //           cmp: String(val.state_name).trim().toUpperCase(),
      //         };
      //       });
      //     }
      //     console.log(this.cityOptions, "ALL CITY");
      //     this.cityOptions = this.cityOptions.sort((a, b) =>
      //       a.cmp.localeCompare(b.cmp)
      //     );
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
      axios(config)
        .then((result) => {
          const { data } = result;
          if (data && data.Records && data.Records.length) {
            this.cityOptions = data.Records.map((val) => ({
              state_id: val.state_id || "",
              state_name: val.state_name || "",
              state_name_ar:
                this.langName === "ar"
                  ? this.translateToArabic(val.state_name)
                  : val.state_name,
              cmp: String(val.state_name)
                .trim()
                .toUpperCase(),
            }));

            this.translatedStates = this.cityOptions.sort((a, b) =>
              a.cmp.localeCompare(b.cmp)
            );
            // console.log("Translated States:", this.translatedStates);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // onValidate() {
    //   this.carrerDeatils.errorMessage = "";
    //   if (this.carrerDeatils.fullName == "") {
    //     ("Enter Your Full Name");
    //   }
    // },

    uploadImage: function(e) {
      this.carrerDeatils.errorMessage = "";

      let self = this;
      var image = e.target.files[0];
      // image = image[0];
      let url = `${BASEURL_BRIJ}/uploadfileContactUs`;

      this.FileName = image.name;
      var formdata = new FormData();

      formdata.append("file", image);

      axios
        .post(url, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          const { data } = response;
          console.log({ data }, `${data.imageBaseURL}${data.path}`);

          if (data.status) {
            console.log(`${data.imageBaseURL}${data.path}`);
            // self.ImageURL = `${data.imageBaseURL}${data.path}`;
            self.ImageURL = `${data.fullpath}`;
          } else {
            self.carrerDeatils.errorMessage = data.message || "Upload Error";
            self.$root.$emit("bv::show::modal", "errorModal");
          }
        })
        .catch(function(error) {
          self.$root.$emit("bv::show::modal", "errorModal");
          console.log(error);
        });
      // makeRequest("/commonUploadFiles", "POST", null, formdata)
      //   .then(response => {
      //     const { data } = response;
      //     console.log("data :", data);
      //   })
      //   .catch(error => {
      //     console.log("error :", error);
      //   });
    },
    validateForm() {
      let value = true;
      this.carrerDeatils.errorMessage = "";
      let MobileData = this.carrerDeatils.Mobile;
      const regex = /^[a-zA-Z\s]+$/;
      // this.chekboxes.errorMessage = "";
      if (this.carrerDeatils.status == "") {
        this.carrerDeatils.errorMessage = "Please Choose Which Feild";
        return false;
      } else if (this.carrerDeatils.fullName == "") {
        this.carrerDeatils.errorMessage = "Full Name Cannot be Empty";
        return false;
      } else if (!regex.test(this.carrerDeatils.fullName)) {
        this.carrerDeatils.errorMessage = "Invalid Character in Name Field";
        return false;
      } else if (
        this.carrerDeatils.Email == "" ||
        /\S+@\S+\.\S+/.test(this.carrerDeatils.Email) == false
      ) {
        this.carrerDeatils.errorMessage =
          "Email Address Cannot be Empty / Invalid Email";
        return false;
      } else if (
        MobileData == "" ||
        MobileData.startsWith("0") ||
        MobileData.length > 9 ||
        MobileData.length < 9 ||
        this.results.isValid == false
      ) {
        // alert();
        this.carrerDeatils.errorMessage = "Mobile Number is Invalid";
        return false;
      }
      // else if (this.carrerDeatils.formatInternational == "") {
      //   this.carrerDeatils.errorMessage = "Mobile Number Cannot be Empty";
      //   return false;
      // }
      else if (this.carrerDeatils.CityName == "") {
        this.carrerDeatils.errorMessage = "Please Selct your city";
        return false;
      } else if (this.ImageURL == "") {
        this.carrerDeatils.errorMessage = "Please Upload Your C.V";
        return false;
      } else if (this.carrerDeatils.Message == "") {
        this.carrerDeatils.errorMessage = "Message Cannot be Empty";
        return false;
      } else {
        return true;
      }
    },
    onFinalSubmit(event) {
      if (this.validateForm()) {
        let payload = {
          // Contact_name: this.contactUsDeatils.Name,
          // Contact_mobile: this.contactUsDeatils.Mobile,
          // Contact_email: this.contactUsDeatils.Email,
          // Contact_message: this.contactUsDeatils.Message,
          // Cinemaname: this.SelectedCinema,
          stc_id: "2",
          name: this.carrerDeatils.fullName || "User from Website",
          fieldOpr:
            this.carrerDeatils.status == "Operational"
              ? "Operational Jobs"
              : "Corporate Jobs",
          // fieldCorp: this.carrerDeatils.status2 == "B" ? "" : "",
          email: this.carrerDeatils.Email,
          toemail: "jobs@empirecinemas.com.sa",
          cityName: this.carrerDeatils.CityName,
          // message: this.carrerDeatils.Message,
          message: this.carrerDeatils.Message,
          // contact_no: this.carrerDeatils.Mobile,
          contact_no: this.results.formatInternational,
          attachment: this.ImageURL,
          FileName: this.FileName,
        };
        makeRequestBrij("/api/external/mail", "POST", null, payload)
          .then((response) => {
            const { error, res } = response;
            this.hideLoading();
            if (!error) {
              if (res.data.status) {
                // this.contactUsDeatils.errorMessage = res.data.Message;
                this.carrerDeatils.fullName = "";
                this.carrerDeatils.Mobile = "";
                this.carrerDeatils.Email = "";
                this.carrerDeatils.Message = "";
                this.ImageURL = "";
                this.FileName = "No File";
                this.SuccessMessage = res.data.message;
                setTimeout(() => {
                  this.$refs.modal_1.show();
                }, 1000);
                event.target.reset();
              } else {
                this.carrerDeatils.errorMessage = res.data.message;
              }
            }
          })
          .catch((error) => {
            console.log("Error", error);
            this.carrerDeatils.errorMessage = "";
          });
      }
    },
  },
};
</script>
<style scoped>
.font-bold {
  font-weight: bold;
}
.custom-width-svg {
  width: 10%;
}
#uploadFilecarrer::placeholder {
  color: #000;
}
#uploadFilecarrer_ar::placeholder {
  color: #000;
}
.vue-phone-number-input ::placeholder {
  color: transparent;
}
#MazPhoneNumberInput-81_phone_number::placeholder {
  opacity: 0;
}
.input-tel__input::placeholder {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/career.vue